<template>
  <div>
    <!-- 修改密码 -->
    <van-notice-bar background="#fef0f0" color="#f56c6c" v-if="resetPwdModal.error">{{ resetPwdModal.error }}</van-notice-bar>
    <van-form ref="resetPwdForm">
      <van-cell-group>
        <PwdInput v-model:pwd="resetPwdModal.form.oldPwd" label="当前密码" :rules="resetPwdModal.rules.oldPwd" name="oldPwd" />
        <PwdInput v-model:pwd="resetPwdModal.form.pass" label="新设密码" :rules="resetPwdModal.rules.pass" name="pass" />
        <PwdInput v-model:pwd="resetPwdModal.form.checkPass" label="确认密码" :rules="resetPwdModal.rules.checkPass" name="checkPass" />
      </van-cell-group>
      <div style="margin: 16px;">
        <van-button block type="primary" @click="submitForm('resetPwdForm')">
          保存
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
  import PwdInput from 'components/mobile/common/PwdInput'
  import { showMessage } from 'api/base/mobile/message'
  import { checkPassword } from 'utils/mobile/common.js'
  import { UpdatePWD } from 'api/user/auth/login'
  export default {
    components: {
      PwdInput
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      let validatePass = (value, rule) => {
        if (value === '') {
          return '请输入密码'
        } else {
          // if (this.resetPwdModal.form.checkPass !== '') {
          //   this.$refs.resetPwdForm.validateField('checkPass');
          // }
          // callback();
          return true
        }
      };

      let validatePass2 = (value, rule) => {
        if (value === '') {
          return '请再次输入密码';
        } else if (value !== this.resetPwdModal.form.pass) {
          return '两次输入密码不一致!'
        }
      };

      return {
        resetPwdModal: {
          visible: this.visible,
          error: '',
          form: {
            oldPwd: '',
            pass: '',
            checkPass: ''
          },
          rules: {
            pass: [
              { required: true, message: '密码不能为空', trigger: 'onBlur' },
              { required: true, validator: checkPassword, trigger: 'onBlur' },
              { required: true, validator: validatePass, trigger: 'onBlur' }
            ],
            checkPass: [
              { required: true, message: '密码不能为空', trigger: 'onBlur' },
              { required: true, validator: checkPassword, trigger: 'onBlur' },
              { required: true, validator: validatePass2, trigger: 'onBlur' }
            ],
            oldPwd: [
              { required: true, message: '请输入当前密码', trigger: 'onBlur' }
            ]
          }
        }
      }
    },
    methods: {
      submitForm(formName) {
          this.$refs[formName].validate().then(() => {
            UpdatePWD(this.resetPwdModal.form)
              .then((res) => {
                if (res.hasOwnProperty("error") && res.error === 'Not Login') {
                  this.$emit('update:loginVisible', true);
                  this.closeRestPwdModal();
                }
                if (!res.result) {
                  this.closeRestPwdModal()
                } else {
                  this.resetPwdModal.error = res.msg;
                }
              }).catch((err) => {
                showMessage('服务异常，请稍后再试')
              })
            }).catch(err=>{
            });
      },
      closeRestPwdModal() {
        this.resetPwdModal.error = '';
        this.resetPwdModal.visible = false;
        this.$refs.resetPwdForm.resetValidation();
        this.$emit('closePwdModal')
      }
    },
    watch: {
      visible: {
        handler(val) {
          this.resetPwdModal.visible = val;
        },
        deep: true
      }
    }
  }
</script>
